import apiFetech from "../configs/axios";

export class OrdersServices {
  // ** Get My Order
  static getMyOrders({ token }) {
    var config = {
      method: "get",
      url: "customer/order",
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    return apiFetech(config);
  }
  // ** Get My Order Next Page
  static getMyOrdersNextPage({ token, url }) {
    var config = {
      method: "get",
      url: `${url}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    return apiFetech(config);
  }

  // ** Create Order
  static createNewOrder({ token, providerID, formData,url_key }) {
    var config = {
      method: "post",
      url: `order/createOrder/${providerID}?payment_type=${url_key}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: formData
    };
    return apiFetech(config);
  }

  // ** orders status
  static ordersStatus({ token }) {
    var config = {
      method: "get",
      url: `provider/orders/status`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    return apiFetech(config);
  }

  static getWhereID({ orderID, token }) {
    var config = {
      method: "get",
      url: `customer/order/${orderID}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    return apiFetech(config);
  }

  static reOrder({ orderID, token }) {
    var config = {
      method: "post",
      url: `re_order/${orderID}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    return apiFetech(config);
  }

  static customerSendMessage({ orderID, token, message }) {
    var config = {
      method: "post",
      url: `customer/order/${orderID}/chat`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data:message
    };
    return apiFetech(config);
  }

  // ** Add Coupon Discount in the Order
  static addCouponDiscountInOrder({providerID ,copounCode,token}) {
    var config = {
      method: "get",
      url: `order/check_capon/provider/${providerID}?copoun_code=${copounCode}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
    };
    return apiFetech(config);
  }


}
//statusList = [{code:1}]
